import { render, staticRenderFns } from "./TemplateCreateWizardStatusTransitionStep.vue?vue&type=template&id=2791b579&scoped=true&"
import script from "./TemplateCreateWizardStatusTransitionStep.vue?vue&type=script&lang=ts&"
export * from "./TemplateCreateWizardStatusTransitionStep.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateCreateWizardStatusTransitionStep.vue?vue&type=style&index=0&id=2791b579&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2791b579",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VBtn,VCard,VDivider,VIcon,VList,VListItem,VListItemContent,VListItemGroup,VListItemTitle,VSubheader})
